import React, { PureComponent } from 'react';

import withSlide from '~/kits/general/scripts/components/withSlide';
import ComparisonMap from '~/kits/general/scripts/components/ComparisonMap';
import { getColorScale } from '~/kits/general/scripts/components/ComparisonMap/utils';
import { getMapDataByKey, getDonutDataByKey } from '~/kits/general/scripts/data-utils';

const colorScale = getColorScale([
  [0, '#9ff792'],
  [3, '#8ae17e'],
  [6, '#75cd6b'],
  [9, '#60b858'],
  [12, '#4ba345']
]);

const mapData = getMapDataByKey('eco');
const donutData = getDonutDataByKey('eco', '#005824');
const maxLegendValue = 36;

class GreenMap extends PureComponent {
  render() {
    const { title, text, isActive } = this.props;

    return (
      <ComparisonMap
        title={title}
        text={text}
        isActive={isActive}
        mapData={mapData}
        colorScale={colorScale}
        donutData={donutData}
        maxLegendValue={maxLegendValue}
      />
    );
  }
}

export default withSlide(GreenMap);
